<template>
  <div>
    <vs-popup
      fullscreen
      class="profile-card"
      title="Editor"
      :active.sync="flag"
    >
      <iframe
        :src="`/editor/about?organization=${organizationSlug}&token=${autoLoginToken}`"
        fullscreen
        frameBorder="0"
        class="editor-iframe"
      ></iframe>
    </vs-popup>
    <vs-popup
      class="profile-card"
      width="1100px"
      :title="title"
      :active.sync="profileCardPopupActive"
    >
      <div class="vx-row mb-base">
        <div
          class="vx-col w-full lg:w-1/3 xl:w-1/3 items-center"
          style="position: relative"
        >
          <vs-avatar class="profile-picture" size="100px" :src="src" />
        </div>
        <div class="vx-col w-full lg:w-2/3 xl:w-2/3">
          <h1>{{ name }}</h1>
          <p class="mt-4">{{ description }}</p>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="profile-card"
      :title="title"
      :active.sync="systemCardPopupActive"
    >
      <div class="vx-row mb-base">
        <div class="vx-col w-full lg:w-4/4 xl:w-4/4">
          <p>{{ description }}</p>
        </div>
      </div>
    </vs-popup>
    <section class="bg-white mt-6 md:mt-0">
      <div class="container w-full lg:w-3/4">
        <div class="flex flex-wrap w-full margin-fix"></div>
        <div></div>
        <div class="step" :class="autoLoginToken ? 'status-1' : 'status-1'">
          <div class="line"></div>
        </div>
        <div class="step" :class="activateFeedback ? 'status-1' : 'status-1'">
          <div class="flex">
            <div class="line step-1"></div>
            <div id="outerContainer">
              <div id="container">
                <div class="item"></div>
                <div class="circle" style="animation-delay: 0s"></div>
                <div class="circle" style="animation-delay: 1s"></div>
                <div class="circle" style="animation-delay: 2s"></div>
                <div class="circle" style="animation-delay: 3s"></div>
              </div>
            </div>

            <!--            <CheckpointCircle :active="isUserLoggedIn && autoLoginToken" />-->
          </div>
          <div class="flex flex-wrap w-full margin-fix ml-12">
            <div class="w-full md:w-1/1 p-3 mt-8 ml-12">
              <h2 class="mt-10 ml-12 font-semibold">Te damos la bienvenida</h2>
            </div>
          </div>
        </div>
        <div class="step" :class="activateFeedback ? 'status-1' : 'status-1'">
          <div class="flex" ><div class="line step-1 user-drag-none"></div>
            <div class="z-50 relative justify-between items-center md:h-64">
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/warm-up-outer.png"
                class="checkpoint-circle user-drag-none"
                width="190px;"
                height="190px;"
              />
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/warmup-logo.png"
                class="checkpoint-circle user-drag-none absolute logo"
              />
              <span class="logo-text mt-4 absolute">
                <h5><b>Warm-up</b></h5>
                <p class="mt-4">
                  Realizaremos un test de autoevaluación previo a cada sesión
                </p>
              </span>
            </div>

            <!--            <img-->
            <!--              :src="active ? $options.colored : $options.grey"-->
            <!--              class="checkpoint-circle"-->
            <!--              width="52px"-->
            <!--              height="52px"-->
            <!--            />-->
            <!--            <CheckpointCircle :active="isUserLoggedIn && autoLoginToken" />-->
          </div>

          <div class="flex flex-wrap w-full margin-fix relative mt-12">
            <div class="w-full md:w-1/1 p-3 mt-12">
              <vx-card :class="isUserLoggedIn ? 'active' : 'inactive'">
                <vs-collapse-item icon-arrow="none">
                  <div slot="header">
                    <div class="flex justify-between items-center">
                      <div class="flex flex-wrap w-11/12">
                        <div class="card-image">
                          <img
                            v-if="isUserLoggedIn"
                            src="../../../../../assets/images/pages/emotionhack/growing-plant.svg"
                            width="52px"
                            height="52px"
                          />
                          <img
                            v-else
                            src="../../../../../assets/images/icons/alex/alex_myprofile_grey.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                        <div class="text-left w-4/5 md:w-0">
                          <p class="path-heading mb-2" style="color: #000000">
                            <b>Warm-up</b>
                          </p>
                          <p class="mb-2">
                            Realizaremos un test de autoevaluación previo a cada
                            sesión
                          </p>
                        </div>
                        <div style="float:right">
                          <vs-collapse accordion v-if="isUserLoggedIn">
                          </vs-collapse>
                        </div>
                      </div>
                      <div class="card-action w-1/12">
                        <img
                          v-if="isUserLoggedIn"
                          src="../../../../../assets/images/pages/emotionhack/accordian.svg"
                          width="45px"
                          class="cursor-pointer"
                          height="auto"
                          @click="$emit('rightArrowClicked')"
                        />
                        <img
                          v-else
                          src="../../../../../assets/images/pages/emotionhack/accordian.svg"
                          width="45px"
                          height="auto"
                        />
                      </div>
                    </div>
                  </div>
                  <emotion-hack-personality
                    v-if="isUserLoggedIn"
                    class="mt-12"
                  ></emotion-hack-personality>
                </vs-collapse-item>
              </vx-card>
            </div>
          </div>
        </div>

        <div
          class="step md:mb-24 p-0"
          :class="activateCompetency ? 'status-1' : 'status-1'"
        >
          <div class="flex relative">
            <div class="line user-drag-none relative md:top-32"></div>
            <div class="z-50 user-drag-none relative sm-left">
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/training-outer.png"
                class="checkpoint-circle user-drag-none"
                width="190px;"
                height="190px;"
              />
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/training-logo.png"
                class="checkpoint-circle user-drag-none absolute logo logo-2"
                width="190px;"
                height="190px;"
              />
              <span class="absolute logo-text logo-text-2">
                <h5><b>Training</b></h5>
                <p>
                  Sesiones prácticas de 3 horas de duración máximo 6 personas
                </p>
              </span>
            </div>

            <!--            <CheckpointCircle :active="activateCompetency" />-->
          </div>
          <div class="mt-2 md:mt-12">
            <div>
              <div
                class="
                  flex
                  items-center
                  flex-wrap
                  margin-fix
                  w-full
                  mt-2
                  md:mt-6
                  justify-between
                  md:justify-start
                "
              >
                <div class="col-md-6">
                  <h2 class="mb-3 text-left mt-1 md:mt-12 mx-5 md:mx-0">
                    <b>Training</b>
                  </h2>
                </div>
                <div class="md:mt-6 col-md-6">
                  <a href="#">
                    <img
                      src="../../../../../assets/images/pages/emotionhack/colored-arrow.svg"
                      class="md:mt-4 ml-4 training-arrow"
                      height="auto"
                    />
                  </a>
                </div>
                <p class="text-sm text-left">
                  Sesiones prácticas de 3 horas de duración máximo 6 personas
                </p>
              </div>
              <h5 class="mb-2 mt-10 font-bold">e_hacks</h5>
              <vx-card
                noShadow
                :class="
                  activateCompetency ? 'alex-preferences' : 'alex-preferences'
                "
                class="border: #eaf1fb;"
              >
                <div class="flex flex-wrap items-strech w-full mt-1 mb-2">
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/60587818b64e18285ca20985"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Toma de decisiones
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/group1.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/6058784bb64e18285ca20987"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Gestión del tiempo
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/Time_management_w_1.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/60587c12b64e18285ca20989"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Resiliencia
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/Resilience_w.svg"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/61d5a5675d8b057b31fb11da"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Autoestima
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/Self_esteem_w.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/6142f38cee9eef1321fb35f1"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Asertividad
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/Assertiveness_w.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="w-full md:w-1/3 p-3 mt-1">
                    <a
                      href="https://app.emotionhack.com/course/60a2cdeb59320007f0f9e675"
                    >
                      <div
                        class="row"
                        style="
                          background: #7b40e9;
                          height: 100px;
                          border-radius: 10px;
                        "
                      >
                        <div class="card-image float-left">
                          <h5
                            class="mb-2 ml-4 mt-10 font-bold"
                            :class="
                              systemCheck1 && activateCompetency
                                ? 'active-image-wrapper'
                                : 'active-image-wrapper'
                            "
                            style="color: white"
                          >
                            Comunicación
                          </h5>
                        </div>

                        <div class="card-image float-right">
                          <img
                            class="mr-2 mt-6"
                            src="../../../../../assets/images/pages/emotionhack/Communication_w.png"
                            width="52px"
                            height="52px"
                          />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </vx-card>
            </div>
            <Library class="w-full" />
          </div>
        </div>
        <div class="step items-start status-0" style="margin-bottom: 0">
          <div class="flex relative">
            <div class="z-50 relative">
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/Integración-outer.png"
                class="checkpoint-circle user-drag-none"
                width="190px;"
                height="190px;"
              />
              <img
                src="../../../../../../src/assets/images/pages/emotionhack/Integración-logo.png"
                class="checkpoint-circle user-drag-none absolute logo logo-3"
              />
              <span class="absolute logo-text logo-text-3">
                <h5><b>Integración</b></h5>
                <p>A través de peer coaching con compañeros</p>
              </span>
            </div>
            <!--            <CheckpointCircle :active="activateCompetency ? true : false" />-->
          </div>
          <div class="flex flex-wrap margin-fix items-strech w-full mt-8">
            <div class="w-full md:w-1/1 p-3">
              <h1 class="mb-3 text-left mt-12"><b>Integración</b></h1>
            </div>
            <div class="w-full md:w-1/2 p-3" v-if="boardSlug">
              <MyPathCard
                :isActive="activateFeedback"
                :currentPath="$options.PATH_NAMES.FEEDBACK"
                @rightArrowClicked="$router.push(`#`)"
              />
            </div>
            <div class="w-full md:w-1/2 p-3" v-else>
              <MyPathCard
                :isActive="activateFeedback"
                :currentPath="$options.PATH_NAMES.FEEDBACK"
                @rightArrowClicked="$router.push(`#`)"
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="activateCompetency"
                :currentPath="$options.PATH_NAMES.COMPETENCIES"
                @rightArrowClicked="$router.push(`#`)"
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="isUserLoggedIn && userProgress === 3"
                :currentPath="$options.PATH_NAMES.SITUATIONS"
                @rightArrowClicked="$router.push(`#`)"
              />
            </div>
            <div class="w-full md:w-1/2 p-3">
              <MyPathCard
                :isActive="isUserLoggedIn && userProgress === 3"
                :currentPath="$options.PATH_NAMES.JOURNEY"
                @rightArrowClicked="$router.push(`#`)"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <vs-popup
      fullscreen
      :title="$t('alex.competencyReportModalTitle')"
      :active.sync="showCompetencyReport"
    >
      <div style="height: 540px; margin: -1rem">
        <iframe
          :src="`https://gala.talentprint.com/profiles/` + autoLoginToken"
          class="w-full h-full border-0"
        >
        </iframe>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Library from "./MeetingSchedule";
import emotionHackPersonality from "./personality/Main.";
import { PATH_NAMES, MY_PATH } from "@/assets/data/emotionhack";
import MyPathCard from "./MyPathCard";
import CheckpointCircle from "./CheckpointCircle";
import organizationConfig from "@/assets/data/organization-config.js";
import {
  defaultPersonalityTraits_en,
  defaultPersonalityTraits_es,
} from "../../../../../assets/data/personality";

export default {
  components: {
    Library,
    emotionHackPersonality,
    MyPathCard,
    CheckpointCircle,
  },
  PATH_NAMES,
  MY_PATH,
  data() {
    return {
      organizationConfig,
      showCompetencyReport: false,
      switch1: true,
      swicthCondition: true,
      userId: "",
      boardSlug: "",
      flag: false,
      profileCheck1: false,
      profileCheck2: false,
      profileCheck3: false,
      profileCheck4: false,
      profileCheck5: false,
      profileCheck6: false,
      profileCheck7: false,
      systemCheck1: false,
      systemCheck2: false,
      systemCheck3: false,
      systemCheck4: false,
      systemCheck5: false,
      systemCheck6: false,
      profileCardPopupActive: false,
      systemCardPopupActive: false,
      title: "",
      description: "",
      src: "",
      name: "",
    };
  },
  computed: {
    personality() {
      console.log(
        "personality Data",
        this.$store.state.editor.personality.personalityYoulabToken
      );
      return this.$store.state.editor.personality;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    organizationId() {
      console.log(this.$store.state.organization.orgData._id);
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    activatePreferences() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    },
    personalityData() {
      const data = {
        en: defaultPersonalityTraits_en,
        de: defaultPersonalityTraits_en,
        fr: defaultPersonalityTraits_en,
        pt: defaultPersonalityTraits_en,
        es: defaultPersonalityTraits_es,
        nl: defaultPersonalityTraits_en,
        it: defaultPersonalityTraits_en,
      };
      return data;
    },
  },
  methods: {
    switchData(value) {
      if (value === 2) {
        this.swicthCondition = false;
      } else if (value == 1) {
        this.swicthCondition = true;
      }
    },
    openEditor() {
      console.log("openEditor");
      this.flag = true;
    },
    profileActive(value, profileActive) {
      if (profileActive === false) {
        this.profileCardPopupActive = false;
      } else {
        this.profileCardPopupActive = true;
      }
      if (value === 1) {
        this.title = "HIGH MAGE 1";
        this.name = "Eric Schiermeyer";
        this.description =
          "Eric Schiermeyer specializes in the magic of management.";
        this.src = "/img/mage-tower-image.c1009a0c.png";
        this.profileCheck1 = true;
      } else if (value === 2) {
        this.title = "HIGH MAGE 2";
        this.name = "Wright Thurston";
        this.description =
          "Wright Thurston has been nurturing and experimenting with the possibilities of blockchain technology.";
        this.src = "/img/mage-tower-image2.3ba59ee2.png";
        this.profileCheck2 = true;
      } else if (value === 3) {
        this.title = "HIGH MAGE 3";
        this.name = "John Oswald";
        this.description =
          "John Oswald is the mastermind behind the crafting of the potions that have captured the minds and attention of gamers worldwide.";
        this.src = "/img/mage-tower-image3.6efff994.png";
        this.profileCheck3 = true;
      } else if (value === 4) {
        this.title = "HIGH MAGE 4";
        this.name = "Adam Price";
        this.description =
          "Adam Price is the Mage of Engineering, who possesses the power to will things into existence with only his mind. ";
        this.src = "/img/mage-tower-image.c1009a0c.png";
        this.profileCheck4 = true;
      } else if (value === 5) {
        this.title = "HIGH MAGE 5";
        this.name = "Jason Brink";
        this.description =
          "Jason Brink is the master of spells; his words can sway your thoughts and leave you asking for more of his sweet whisper.";
        this.src = "/img/mage-tower-image5.e31e6708.png";
        this.profileCheck5 = true;
      } else if (value === 6) {
        this.title = "HIGH MAGE 6";
        this.name = "James Olden";
        this.description =
          "Our sixth High Mage is James Olden, the Mage of Strategy, whose secret power lies in orchestrating deals and treatises to expand Gala Games influences. ";
        this.src = "/img/mage-tower-image6.9f62a383.png";
        this.profileCheck6 = true;
      } else if (value === 7) {
        this.title = "HIGH MAGE 7";
        this.name = "Sarah Buxton";
        this.description =
          "The last of the Seven High Mages is Sarah Buxton, the Master of Operation. No matter the size of the boulder or how high the obstacle is in your way, Sarah will use her secret magic and create a tunnel for your team to pass through. ";
        this.src = "/img/mage-tower-image4.b4d95e31.png";
        this.profileCheck7 = true;
      }
    },
    systemActive(value, systemActiveStaus) {
      if (systemActiveStaus === false) {
        this.systemCardPopupActive = false;
      } else {
        this.systemCardPopupActive = true;
      }
      if (value === 1) {
        this.title = "Tinkergnomies - Engineering ";
        this.description =
          "Now we shall explore some of the many races within the realm of Gala. The first race is the Tinker gnomes, who weave the strings of the great carpet upon which we will all stride to greatness. They dwell between the lines of code and make sure that all programs work perfectly. They are always busy, but very approachable. If it is their assistance you seek, do so by coordinating a meeting through the Mage of Engineering, Adam Price.";
        this.src = "@assets/images/icons/gala/engineering.svg";
        this.systemCheck1 = true;
      } else if (value === 2) {
        this.title = "Arcane gnomes - Game Designers ";
        this.description =
          "Another race of gnomes in our midst are the Arcane gnomes, or the game designers. They like to stay in small groups, focusing on a single particular game project at a time. They are fun-loving people with many cats. They will also be delighted if you ask them to share their screens to show what they are working on!";
        this.systemCheck2 = true;
      } else if (value === 3) {
        this.title = "Halfillings  - Designers ";
        this.description =
          "Halflings are those with whom you may need to frequently interact. They are the designers of all the pretty things. Whether it’s web pages, documents, presentations, or user interfaces, the halflings can get it done. You will be just amazed at the end result of their wonderful work.";
        this.systemCheck3 = true;
      } else if (value === 4) {
        this.title = "Acolytes - Customer Service ";
        this.description =
          "Acolytes, or customer service representatives are another race to whom you should be paying attention. They take care of the Gala Games community and help keep the trolls and monsters at bay. If you want a good laugh and a funny troll story, buy one of them a big mug of beer at the end of a long day.";
        this.systemCheck4 = true;
      } else if (value === 5) {
        this.title = "Arcane Warlocks - Legal ";
        this.description =
          "The Arcane Legal Warlocks are an important race, and one with whom you should be familiar, adventurer. Warlocks are responsible for all the contracts or other binding spells that you may need to cast. Always be safe by passing your binding spells or legal documents to the Warlocks before you wave your wand to bind yourself and Gala Games.";
        this.systemCheck5 = true;
      } else if (value === 6) {
        this.title = "The Changeling - Hr and Finance ";
        this.description =
          "Finally, we have the Changeling HR/Finance races. They will help get you the documents and funds you need while venturing through the Gala Games realm. If your project needs funds, remember to keep them in the loop!\n" +
          "\n" +
          "You now have a glimpse of the Gala games infrastructure. Your first quest is to become acquainted with each member personally. No worries, they are all very nice and friendly. If by chance they become terse while busy, do not take it personally!";
        this.systemCheck6 = true;
      }

      console.log("hello");
    },
  },

  created() {
    let url = this.$route.path.split("/");
    this.boardSlug = url[2];
    this.userId = url[3];
    // this.$store
    //   .dispatch("boards/fetchUserBoardData",this.userId )
    //   .then((res) => {
    //
    //     // this.$store.commit(
    //     //   "boards/SET_USER_BOARD_DATA",
    //     //   res.data
    //     // );
    //     // console.log('res.data',res.data);
    //
    //   })
    //   .catch((err) => {
    //     throw err;
    //   });
  },
};
</script>
<style scoped>
.circle {
  border-radius: 50%;
  background-color: #7b40e9;
  margin-left: 5%;
  width: 70px;
  height: 70px;
  position: absolute;
  opacity: 0;
  animation: scaleIn 4s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
}

@keyframes scaleIn {
  from {
    transform: scale(0.5, 0.5);
    opacity: 0.5;
  }
  to {
    transform: scale(2.5, 2.5);
    opacity: 0;
  }
}
.text-sm {
  display: none;
}
.custom-width {
  width: 100%;
}
.logo {
  height: 3.5em;
  width: 3.5em;
  left: 35%;
  top: 8%;
}
.logo-2 {
  top: 2.5%;
}

.logo-text {
  width: 10%;
  text-align: center;
  left: 10%;
  top: 30%;
  width: 75%;
  font-size: 0.8em;
}
.logo-text-2 {
  top: 10%;
}
.logo-text-3 {
  top: 45%;
}
p {
  line-height: unset;
  font-size: unset;
}
h5 {
  font-weight: bold;
}
h1 {
  color: #231d4f;
  font-weight: 400;
}
.alex-preferences {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(71, 100, 195, 0.1);
}
section {
  padding-top: 8rem;
}

.alex-preferences p,
.alex-preferences h5 {
  color: #f29300;
}

.s-head {
  margin-bottom: 0.2rem;
}

.active p.s-head {
  color: #f29300;
}
.step-headline.active,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.inactive h5,
.inactive p {
  color: #ccc !important;
}
.step-headline.inactive {
  color: #ccc !important;
}
.step {
  position: relative;
  display: flex;
}

.step:not(:last-child) {
  padding-bottom: 6rem;
}
.step:last-child {
  padding-bottom: 12rem;
}
.step > div:first-child img {
  z-index: 1;
  background: #fff;
  border-radius: 50%;
}
.line {
  position: absolute;
  left: 90px;
  top: 4em;
  bottom: 0px;
}
.line:only-child {
  top: 30px;
  bottom: 4px;
}
.step-1 {
  bottom: 4px;
}
.step.status-0 > div:first-child >>> .line {
  border-left: 6px solid #d0cfcf;
}
.step.status-1 > div:first-child >>> .line {
  border-left: 6px solid #ebebeb;
  border-color: #ebebeb;
}
.step > div:first-child {
  margin-right: 2%;
}
.training-arrow {
  width: 2.5em;
}
.textbox {
  background: #7b40e9;
  border: 1px solid #7b40e9;
  align-items: center;
  border-radius: 4px;
}
.margin-fix {
  margin: -3rem -0.75rem 0 -0.75rem;
}
.realm-ul > li::before {
  content: url("../../../../../assets/images/pages/gala/li-before.png");
  margin-right: 4px;
}
.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  opacity: 0.2;
}
.active-image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  opacity: 1;
}
.editor-iframe {
  width: 100%;
  height: calc(100vh - 150px);
}
.toggle_radio {
  position: relative;
  background: radial-gradient(
      18.95% 15.16% at 29.81% 21.98%,
      rgba(255, 255, 255, 0.6) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #3280fc; /*rgba(255,255,255,.1)*/
  margin: 4px auto;
  overflow: hidden;
  padding: 0 !important;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  height: 36px;
  width: /*318px;*/ 220px;
}
.toggle_radio > * {
  float: left;
}
.toggle_radio input[type="radio"] {
  display: none;
  /*position: fixed;*/
}
.toggle_radio label {
  font: 90%/1.618 Montserrat, Helvetica, Arial, sans-serif;
  color: rgba(255, 255, 255, 0.9);
  z-index: 0;
  display: block;
  width: /*100px;*/ 110px;
  height: 30px;

  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1;
  /*background: rgba(0,0,0,.1);*/
  text-align: center;
  /*margin: 0 2px;*/
  /*background: blue;*/ /*make it blue*/
}
.toggle_radio label p {
  padding: 3px;
}
.toggle_option_slider {
  /*display: none;*/
  /*background: red;*/
  width: /*100px;*/ 110px;
  height: 30px;
  position: absolute;
  top: 3px;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.user-drag-none {
  user-drag: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
}

input[id$="_first_toggle"]:checked ~ .toggle_option_slider {
  background: #933eb9;
  left: 3px;
}
input[id$="_second_toggle"]:checked ~ .toggle_option_slider {
  background: #933eb9;
  left: /*109px*/ 115px;
}
input[id$="_third_toggle"]:checked ~ .toggle_option_slider {
  background: #933eb9;
  left: /*215px;*/ 135px;
}
.start-logo {
  width: 6em;
  height: 6em;
  left: 6.5%;
  position: relative;
}
@media screen and (max-width: 500px) {
  .text-sm {
    display: block;
    color: #848199;
    margin-top: 0.5em;
  }
  .margin-fix {
    margin: -0.75rem;
  }
  .step > div:first-child img:first-child {
    height: 4.5em;
    width: 4.5em;
  }
  .line {
    left: 2em;
  }
  section {
    padding: 0;
  }
  .logo {
    left: 11%;
    top: 3.5%;
  }
  .logo-text {
    display: none;
  }
  .logo-2 {
    top: 0.5% !important;
  }
  .logo-3 {
    top: 9.5%;
  }
  .vx-card >>> .vx-card__body {
    padding: 0.2rem !important;
  }
  .step:not(:last-child) {
    padding-bottom: 2rem;
  }
  .start-logo {
    left: 5%;
    position: relative;
    top: 30%;
    width: 4em;
    height: 4em;
  }
  .sm-left {
    left: -7%;
  }
}
</style>
